import { useVisualComponentsContext } from '../../contexts/visualComponents';
import { useQueryHistoryStateContext, useQueryStateContext } from '../../contexts';
import { useAddCriteria } from '../../hooks/criteria';

export const AddButton = () => {
  const { AddCriteriaButton } = useVisualComponentsContext();
  const { isReadOnly = false } = useQueryStateContext();
  const addCriteria = useAddCriteria();
  const { resetRedoStack } = useQueryHistoryStateContext();

  if (isReadOnly) return null;

  return (
    <AddCriteriaButton
      isDisabled={isReadOnly}
      onClick={() => {
        addCriteria();
        resetRedoStack();
      }}
    />
  );
};
